import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, UrlTree } from '@angular/router'

import { Observable } from 'rxjs'

import { ToastMessageService } from '@flowx/designer/shared/services/toast-message.service'

import { resolveLanding } from '../guards/landing.guards'
import { WorkspacesAndPermissionsStore } from '../workspaces-and-permissions.store'

const WORKSPACE_NO_ACCESS_MESSAGE =
  'You do not have access to this workspace, or the link is not valid'

/**
 * A workspace the user can't open, or one that doesn't exist, leads where the landing would with
 * an error toast. It guards everything inside the workspace, so the workspace is checked before
 * any of its projects.
 */
export const workspaceAccessGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): true | Observable<UrlTree> => {
  const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)
  const toastMessageService = inject(ToastMessageService)
  const workspaceId = route.paramMap.get('workspaceId')

  const hasAccess = workspacesAndPermissionsStore
    .availableWorkspacesForUser()
    .some((workspace) => workspace.id === workspaceId)

  if (hasAccess) {
    return true
  }

  toastMessageService.showErrorMessage(WORKSPACE_NO_ACCESS_MESSAGE)
  return resolveLanding()
}
